import request from '@utils/request'

export function fetchOtps(params) {
  return request({
    url: '/admin/otp',
    method: 'get',
    params,
  })
}

export function deleteOtp(otp_seq) {
  return request({
    url: `/admin/otp/${otp_seq}`,
    method: 'delete',
  })
}
